<template>
    <div class="sideMenu_window">
        <div class="sideMenu-nav-content">
            <nav class="nav flex-column">
                <router-link
                    v-for="link in links"
                    :key="link.id"
                    :class="link.class"
                    :to="link.to"
                    :name="link.name"
                    active-class="sideMenu__inner__selected"
                >{{ link.title }}

                    <div class="Helppage_GreaterThan">&gt;</div>
                </router-link>
            </nav>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            links: [
                {
                    id: 1,
                    title: "新規登録に関して",
                    class: "nav-link sideMenu__inner__itemss",
                    to: "/help",
                    name: "help-make"
                },
                {
                    id: 2,
                    title: "登録内容の変更に関して",
                    class: "nav-link sideMenu__inner__itemss",
                    to: "/help-accountedit",
                    name: "help-accountedit"
                },
                {
                    id: 3,
                    title: "パスワードを忘れた場合",
                    class: "nav-link sideMenu__inner__itemss",
                    to: "/help-passforget",
                    name: "help-passforget"
                },
                // クラシック用にコメントアウト
                // {
                //     id: 4,
                //     title: "ポイントに関して",
                //     class: "nav-link sideMenu__inner__itemss",
                //     to: "/help-point",
                //     name: "help-point"
                // },
                {
                    id: 4,
                    title: "マイページの機能に関して",
                    class: "nav-link sideMenu__inner__itemss",
                    to: "/help-mypage",
                    name: "help-mypage"
                },
                {
                    id: 5,
                    title: "予約に関して",
                    class: "nav-link sideMenu__inner__itemss",
                    to: "/help-reserve-change",
                    name: "help-reserve-change"
                }
            ]
        };
    },
    created() {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
        }
    }
};
</script>

<style scoped>
</style>
